import React, { useState } from 'react';

import { useCurrentUser, usePowerlist } from '../../hooks';
import { PowerlistPersonData } from '../../utils/backend-api/powerlist';
import PowerlistHeader from '../Powerlist/PowerlistHeader';
import PowerlistSection from '../Powerlist/PowerlistSection';
import styles from './styles.module.scss';

export interface PowerlistPersonDetails extends PowerlistPersonData {
  rowNum: string;
}

const Layout = () => {
  const [details, setDetails] = useState<PowerlistPersonDetails>(null);

  const { data, isLoadingPowerlist } = usePowerlist('enterprise');
  const { currentUser } = useCurrentUser();

  const handlePersonClick = (person, rowNum) => {
    setDetails({ ...person, rowNum });

    // @ts-expect-error trackEvent set on window object in app/javascript/packs/application.js
    window.trackEvent('enterprise-powerlist-profile-click', {
      person: person.name,
      user_id: currentUser?.id,
      email: currentUser?.email,
      page: window.location.pathname,
    });
  };

  const handleClose = () => {
    setDetails(null);
  };

  return (
    <>
      {!isLoadingPowerlist && (
        <>
          <PowerlistHeader />
          <div className="container-fluid operators" id={styles.operatorsSection}>
            {data?.executives && (
              <PowerlistSection
                details={details}
                handleClose={handleClose}
                handlePersonClick={handlePersonClick}
                section={data.executives}
                sectionNum={1}
                title={'Executives'}
              />
            )}
          </div>
          <div className="container-fluid investors" id={styles.investorsSection}>
            {data?.investors && (
              <PowerlistSection
                details={details}
                handleClose={handleClose}
                handlePersonClick={handlePersonClick}
                section={data.investors}
                sectionNum={2}
                title={'Investors'}
              />
            )}
          </div>
          <div className="container-fluid emerging" id={styles.emergingSection}>
            {data?.emerging && (
              <PowerlistSection
                corpOrGroupSubscriber={currentUser?.is_corp_or_group_subscriber}
                details={details}
                handleClose={handleClose}
                handlePersonClick={handlePersonClick}
                section={data.emerging}
                sectionNum={3}
                title={'Up & Comers'}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Layout;
